import { LoadingScreen } from '@/components/common/LoadingScreen';
import { useAuth } from '@/hooks/useAuth';
import Profile from '@/pages/Profile';
import React, { useState } from 'react';
import { TermsGuard } from './TermsGuard';

interface ManagerGuardProps {
  children: React.ReactNode;
}

export const ManagerGuard: React.FC<ManagerGuardProps> = ({ children }) => {
  const { user, hasManagerRole, isLoadingUser } = useAuth();
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  if (isLoadingUser) {
    return <LoadingScreen />;
  }

  const isManagerWithoutId =
    hasManagerRole && user && (!user.id || user.id.trim() === '');

  if (isManagerWithoutId && !isProfileCompleted) {
    return (
      <Profile
        isFullScreen={true}
        onProfileComplete={() => setIsProfileCompleted(true)}
      />
    );
  }

  return <TermsGuard>{children}</TermsGuard>;
};
